import React from 'react';

interface IconProps {
  color?: string;
  height?: number;
}

const IconImportTable: React.FC<IconProps> = ({ color = '#B689E3', height = 44 }) => (
  <svg width="47" height={height} viewBox="0 0 47 44" fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path d="M22.3684 39.8947H6.52632C5.32586 39.8947 4.17458 39.4511 3.32573 38.6615C2.47688 37.8719 2 36.8009 2 35.6842V6.21053C2 5.09383 2.47688 4.02286 3.32573 3.23323C4.17458 2.44361 5.32586 2 6.52632 2H38.2105C39.411 2 40.5623 2.44361 41.4111 3.23323C42.26 4.02286 42.7368 5.09383 42.7368 6.21053V23.0526M2 16.7368H42.7368M17.8421 2V39.8947M38.2105 42V29.3684M38.2105 29.3684L45 35.6842M38.2105 29.3684L31.4211 35.6842" 
      stroke={color} 
      strokeWidth="3" 
      strokeLinecap="round" 
      strokeLinejoin="round"/>
  </svg>
);

export default IconImportTable;